import { flagPathPrefixes, pathMatchesPrefix } from './flag-paths'

export function mobileFlagPrefix(portal: string | null | undefined): string | null {
  return portal ? `mobile-v2-${portal}:` : null
}

export function mobilePathPrefixes(flags: string[], portal: string | null | undefined): string[] {
  const flagPrefix = mobileFlagPrefix(portal)
  return flagPrefix ? flagPathPrefixes(flags, flagPrefix) : []
}

export function isMobileReleased(path: string, prefixes: string[]): boolean {
  return pathMatchesPrefix(path, prefixes)
}
